import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/hooks/useI18n";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Advantages from "@/components/Advantages";
import Products from "@/components/Products";
import ImportCustoms from "@/components/ImportCustoms";
import Contacts from "@/components/Contacts";
import RequestForm from "@/components/RequestForm";
import Footer from "@/components/Footer";

const Home = () => {
  useEffect(() => {
    document.title = "CADS — Central Asia Digital Solutions";
  }, []);

  return (
    <div data-testid="cads-home" className="min-h-screen bg-white text-[#0A1933]">
      <Navbar />
      <main>
        <Hero />
        <Advantages />
        <Products />
        <ImportCustoms />
        <Contacts />
        <RequestForm />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="light" richColors />
      </div>
    </I18nProvider>
  );
}

export default App;
